import { connect } from 'react-redux';
import _isEmpty from 'lodash.isempty';
// Actions
import { fetchLists } from '../actions/actions_lists';
import { fetchUser } from '../actions/actions_user';
import { toggleViewListsToAll, toggleViewListsToStarred } from '../actions/actions_view';
// Components
import ChecklistsView from '../views/ChecklistsView';


// Map Redux state to component props
const mapStateToProps = state => {
    return {
        lists: state.lists,
        user: state.user,
        loading: (_isEmpty(state.lists) === true) ? true : false,
        error: state.lists.error ? true : false,
        userLoaded: _isEmpty(state.user.userId) ? false : true,
        viewLists: state.view.viewLists,
        showMsgStarredMaximum: state.view.showMsgStarredMaximum
    }
}


// Connect component
const ContaierChecklistsView = connect(
    mapStateToProps,
    { fetchLists, fetchUser, toggleViewListsToAll, toggleViewListsToStarred }
)(ChecklistsView)


export default ContaierChecklistsView



// WEBPACK FOOTER //
// ./src/containers/ContainerChecklistsView.js